import Sessions from "../../../../src/components/Sessions/Sessions";
import * as React from 'react';
export default {
  Sessions,
  React
};